<div class="header">
    <h2>{{ 'media.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="all-media-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<div class="body">
    <div class="section">
        <h2>{{ 'media.form.type' | translate }}</h2>
        <div class="type-grid">
            @for (type of types; track type.value) {
                <button [class]="'type-card type-card-' + type.value" [attr.data-test]="'all-media-add-type-' + type.value" (click)="selectType(type.value)">
                    <i [class]="type.icon"></i>
                    <span>{{ type.label }}</span>
                </button>
            }
        </div>
    </div>
</div>
